import React, { useEffect, useRef, useState } from 'react';
import styles from './TypewriterTagline.module.css';
import useReducedMotion from '../../hooks/useReducedMotion';

const PHRASES = [
  'Building the next big thing...',
  'Launching cool shit...',
  'Monitoring your activity...',
  'Prompting our agents...',
];

const TYPE_SPEED_MS = 50;
const DELETE_SPEED_MS = 30;
const HOLD_MS = 2000;
const PAUSE_MS = 500;

function TypewriterTagline() {
  const reduceMotion = useReducedMotion();
  const [displayText, setDisplayText] = useState(reduceMotion ? PHRASES[0] : '');
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (reduceMotion) return undefined;

    const phrase = PHRASES[phraseIndex];

    if (!isDeleting && displayText === phrase) {
      timerRef.current = setTimeout(() => setIsDeleting(true), HOLD_MS);
    } else if (isDeleting && displayText === '') {
      timerRef.current = setTimeout(() => {
        setIsDeleting(false);
        setPhraseIndex((i) => (i + 1) % PHRASES.length);
      }, PAUSE_MS);
    } else if (isDeleting) {
      timerRef.current = setTimeout(
        () => setDisplayText(phrase.slice(0, displayText.length - 1)),
        DELETE_SPEED_MS
      );
    } else {
      timerRef.current = setTimeout(
        () => setDisplayText(phrase.slice(0, displayText.length + 1)),
        TYPE_SPEED_MS
      );
    }

    return () => clearTimeout(timerRef.current);
  }, [displayText, isDeleting, phraseIndex, reduceMotion]);

  return (
    <p className={styles.tagline} aria-live="polite">
      <span className={styles.text}>{displayText}</span>
      {!reduceMotion && (
        <span className={styles.cursor} aria-hidden="true">
          ▋
        </span>
      )}
    </p>
  );
}

export default TypewriterTagline;
